export class PageHelper {
    static removePage(pages, pageId) {
        return pages?.filter((page) => page.id !== pageId);
    }
    static renamePage(pages, pageId, name) {
        return pages?.map((page) => (page.id === pageId ? { ...page, name } : page));
    }
}
